import firebase from "firebase/app";

// A login the app refused to attach to an existing account, kept briefly so it can be added to that
// account once the customer signs in with their original method. Its ID token is the proof they own it.
const KEY = "pendingLoginLink";
const MAX_AGE_MS = 55 * 60 * 1000;

export type LoginKind = "phone" | "email";

interface PendingLoginLink {
  token: string;
  kind: LoginKind;
  uid: string;
  savedAt: number;
}

export const loginKindOf = (user: firebase.User): LoginKind => (user.phoneNumber ? "phone" : "email");

export const savePendingLoginLink = async (user: firebase.User) => {
  const pending: PendingLoginLink = {
    token: await user.getIdToken(true),
    kind: loginKindOf(user),
    uid: user.uid,
    savedAt: Date.now(),
  };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(pending));
  } catch (e) {
    // Storage unavailable: the customer just signs in the original way, as before.
  }
};

// Returns the pending link for a different login than `currentUid`, and forgets it.
export const takePendingLoginLink = (currentUid: string): PendingLoginLink | null => {
  let pending: PendingLoginLink | null = null;
  try {
    pending = JSON.parse(window.localStorage.getItem(KEY) || "null");
  } catch (e) {
    return null;
  }
  if (!pending || pending.uid === currentUid) return null;
  try {
    window.localStorage.removeItem(KEY);
  } catch (e) {}
  return Date.now() - pending.savedAt < MAX_AGE_MS ? pending : null;
};
